module.exports = __webpack_public_path__ + "img/tag-2.475ace29.svg";